import { create } from '@storybook/theming/create';
import brandImage from './logo.svg';

export default create({
    base: 'dark',
    brandTitle: 'eloomi design system',
    brandImage,
    brandTarget: '_self',
});
